import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { LayerListItem, TrvMap, TrvNgMapService } from "@trafikverket/trv-ng-map";
import {
    svgBug,
    svgCircleInfo,
    svgInfo,
    svgMagnifyingGlass,
    svgMagnifyingPlus,
    svgMagnifyingPlusFilled,
    svgWarning
} from "src/app/shared/utils/svg-helper-data";
import {
    trvCollapseVoidAnimation,
    TrvModalService,
    TrvTooltipPosition,
    TrvTooltipDirective,
    TrvLoadingBundle,
    TrvSelectComponent,
    TrvFormBundle
} from "@trv-hub/trv-ng-common";
import { NetDbService } from "src/app/service/net-db.service";
import { firstValueFrom, startWith, combineLatest, first, distinctUntilChanged } from "rxjs";
import { SvgIcon } from "src/app/shared/utils/svg-helper";
import { NvdbNavigationService, PlatsSearchOption, YearObjectType } from "src/app/service/nvdb-navigation.service";
import { LayerInfoModalComponent } from "../layer-section/layer-info-modal/layer-info-modal.component";
import { NgClass } from "@angular/common";
import { SvgIconComponent } from "../../utils/svg-icon/svg-icon.component";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { environment } from "src/environments/environment";
import { Event } from "@angular/router";
import { A } from "@angular/cdk/keycodes";
import { ApmService } from "@app/service/apm.service";
import { DataslagTreeComponent } from "../../../dataslag-tree/dataslag-tree.component";
import { Language, LanguageService } from "@app/service/language.service";
import { EventEmitter, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";


@Component({
    selector: "app-dataslag-section",
    templateUrl: "./dataslag-section.component.html",
    styleUrls: ["../../map-menu/map-menu.component.scss", "./dataslag-section.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: [trvCollapseVoidAnimation],
    imports: [SvgIconComponent, NgClass, TrvTooltipDirective, ReactiveFormsModule, TrvLoadingBundle, TrvSelectComponent, TrvFormBundle, DataslagTreeComponent]
})
export class DataslagSectionComponent implements AfterViewInit {
    @ViewChild("scrollContainer", { static: false }) scrollContainer!: ElementRef;
    @Output() yearChanged = new EventEmitter<YearObjectType>(); // Output event for year change
    public searchIcon: SvgIcon = svgMagnifyingGlass;
    public searchIconPlus: SvgIcon = svgMagnifyingPlus;
    public searchIconPlusFilled: SvgIcon = svgMagnifyingPlusFilled;
    public svgBug: SvgIcon = svgBug;
    public svgWarning: SvgIcon = svgWarning;
    public circleInfoIcon: SvgIcon = svgCircleInfo;
    public infoIcon: SvgIcon = svgInfo;

    public toolTipPositions: TrvTooltipPosition[] = ["bottom", "right"];
    //public filteredDataslagLayerIds: string[] = [];
    public dataslagLayers: LayerListItem[] = [];
    public filteredDataslagLayers: LayerListItem[] = [];

    public environment = environment



    public njdbDataslagsFilters: NjdbDataslagFilter[] = [
        {
            id: 0,
            name: "Alla"
        },
        {
            id: 1,
            name: "NJDB-nät"
        },
        {
            id: 2,
            name: "Statligt järnvägsnät"
        }
    ];

    public dataslagSearch = new FormControl("", { nonNullable: true });
    public showChoosenDataslag = new FormControl(false, { nonNullable: true });
    public njdbFilters = new FormControl(this.njdbDataslagsFilters[0]);

    public currentlyFocusedDataslagNumber: number = -1
    availableYearSearchFilter: any;


    constructor(
        @Inject(TrvNgMapService) public trvMapService: TrvNgMapService,
        @Inject(NvdbNavigationService)
        public nvdbNavigation: NvdbNavigationService,
        @Inject(TrvModalService) private trvModalService: TrvModalService,
        @Inject(NetDbService) private netDbService: NetDbService,
        @Inject(ApmService) private apmService: ApmService,
        public lang: LanguageService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit(): void {
        if (environment.application == "JNBKarta") {
            this.route.queryParams.pipe(first()).subscribe((params: { [x: string]: any; }) => {
                const year = params["year"];
                //console.log(year)
                const foundYear = this.nvdbNavigation.availableYearSearchFilter.find(y => y.displayYear === year);

                if (foundYear) {
                    // emitEvent: false förhindrar att valueChanges triggas
                    this.nvdbNavigation?.searchMenuState?.yearObject?.setValue(foundYear, { emitEvent: true });
                } else {
                    const defaultYear = this.nvdbNavigation.availableYearSearchFilter[0];
                    // emitEvent: false förhindrar att valueChanges triggas
                    this.nvdbNavigation?.searchMenuState?.yearObject?.setValue(defaultYear, { emitEvent: true });
                    this.updateYearInUrl(defaultYear.displayYear);
                }
            });

            // distinctUntilChanged förhindrar dubbla triggers
            this.nvdbNavigation?.searchMenuState?.yearObject?.valueChanges.pipe(
                //distinctUntilChanged()
            ).subscribe(selectedYear => {
                if (selectedYear) {
                    this.updateYearInUrl(selectedYear.displayYear);
                    this.yearChanged.emit(selectedYear);
                }
            });
        }

        combineLatest([
            this.trvMapService.trvMap?.trvLayer.layersUpdated.pipe(startWith([])) ?? [],
            this.showChoosenDataslag.valueChanges.pipe(startWith(false)),
            this.dataslagSearch.valueChanges.pipe(startWith("")),
            this.njdbFilters.valueChanges.pipe(startWith(this.njdbDataslagsFilters[0])),

            environment.application == "JNBKarta"
                ? this.nvdbNavigation.searchMenuState.yearObject.valueChanges.pipe(startWith(this.nvdbNavigation.searchMenuState.yearObject.value))
                : new FormControl(null).valueChanges.pipe(startWith(null))

        ]).subscribe(([_, showChoosenDataslag, searchString, njdbFilter]) => {
            if (this.getTrvMap() == null) return;

            let lowercaseSearchString = searchString.toLowerCase();
            this.dataslagLayers =
                this.getTrvMap()?.trvLayer.wmsLayerListItems!.filter(a => a.name.toLowerCase().includes(lowercaseSearchString)).sort((a, b) => a.name.localeCompare(b.name)) ?? [];

            if (showChoosenDataslag) {
                //this.filteredDataslagLayerIds = this.dataslagLayers.filter(a => a.active).map(a => a.id);
                this.filteredDataslagLayers = this.dataslagLayers.filter(layer =>
                    layer.active
                    && !this.showInLayer(layer)
                    && this.showLayerBasedOnLocal(layer))
            } else {
                this.filteredDataslagLayers = this.dataslagLayers.filter(layer =>
                    !this.showInLayer(layer)
                    && this.showLayerBasedOnLocal(layer))
            }

            if (environment.application == "NjdbPåWebb") {
                if (njdbFilter?.name != "Alla" && !showChoosenDataslag) {
                    const trvMap = this.trvMapService.getTrvMap()!;

                    this.filteredDataslagLayers = this.dataslagLayers.filter(layer =>
                        trvMap.trvLayer.getLayerData(layer, "layerCategory") == njdbFilter?.name
                        && !this.showInLayer(layer)
                        && this.showLayerBasedOnLocal(layer))
                }
            } else if (environment.application == "JNBKarta") {
            }
        })

        this.dataslagSearch.valueChanges.subscribe(() => {
            this.showChoosenDataslag.setValue(false)
            this.currentlyFocusedDataslagNumber = -1
        });

    }



    private updateYearInUrl(year: string) {
        const queryParams = { ...this.route.snapshot.queryParams, year };
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: "merge" // Behåller andra query-parametrar
        });
    }

    public displayYearObject = (object: YearObjectType) => {
        return object.displayYear;
    };

    ngAfterViewInit(): void {
        if (environment.application == "NjdbPåWebb")
            this.scrollContainer.nativeElement.scrollTop = this.nvdbNavigation.startMenuState.dataSlagScrollTop;
    }

    public onYearChange(selectedYear: YearObjectType): void {
        if (!selectedYear) return;

        this.yearChanged.emit(selectedYear);
    }


    get selectedYearText(): string {

        if (this.lang.currentLanguage == Language.SV)
            return this.nvdbNavigation.searchMenuState.yearObject.value ? this.nvdbNavigation.searchMenuState.yearObject.value.text : "Något gick fel";
        return this.nvdbNavigation.searchMenuState.yearObject.value ? this.nvdbNavigation.searchMenuState.yearObject.value.textEng : "Something went wrong";
    }

    public displayObjectNjdbFilter = (njdbFilter: NjdbDataslagFilter) => {
        return njdbFilter.name
    }

    public numberOfDataProdukterActive() {
        const trvMap = this.trvMapService.trvMap!;
        const trvLayer = trvMap.trvLayer;
        let dataprod = this.trvMapService.trvMap!.trvLayer.getVisibleWmsLayer().filter(layer => trvLayer.getLayerData(layer, "showInLayer") != true)
        return dataprod.length;
    }

    public disableAllLayers() {
        const trvMap = this.trvMapService.trvMap!;
        const trvLayer = trvMap.trvLayer;
        trvLayer.wmsLayerListItems.forEach(layer => {
            if (layer.active && trvLayer.getLayerData(layer, "showInLayer") != true) {
                trvLayer.setLayerVisibility(layer, false);
            }
        });
    }

    public onScrollEvent(event: any): void {
        const element = event.target as HTMLElement;
        this.nvdbNavigation.startMenuState.dataSlagScrollTop = element.scrollTop;
    }

    public getTrvMap(): TrvMap | undefined {
        return this.trvMapService.trvMap;
    }

    public showLayerBasedOnLocal(layer: LayerListItem): boolean {
        const trvMap = this.trvMapService.trvMap!;
        if (trvMap.trvLayer.hasLayerData(layer, "onlyLocal")) {
            const onlyLocal = trvMap.trvLayer.getLayerData(layer, "onlyLocal") as boolean;
            if (!(environment.local == "true") && onlyLocal) return false;
        }
        return true;
    }

    public showInLayer(layer: LayerListItem): boolean {
        let res = false;
        if (layer.trvData.hasOwnProperty("showInLayer")) {
            let showInLayer = (layer.trvData as any).showInLayer;
            return showInLayer;
        }
        return res;
    }

    public onWmsLayerInputChange(checked: boolean, layer: LayerListItem) {
        this.trvMapService.trvMap?.trvLayer.setLayerVisibility(layer, checked);
    }

    public tmpOnWmsLayerInputChange(event: any, layer: LayerListItem, index: number) {
        this.onWmsLayerInputChange(event.currentTarget.checked, layer)

        this.currentlyFocusedDataslagNumber = index;
    }


    public layerActive(layer: LayerListItem) {
        if (layer) {
            return layer.active;
        }
        return false;
    }

    /**
     * Metod som om, lagret innehåller en maxScaleDenominator, zoomar in till den nivån på kartan.
     * @param layer Lagret som ska zoomas in på
     */
    public zoomToLayer(layer: LayerListItem) {
        this.trvMapService.trvMap!.zoomInOnLayerMaxScaleDenominator(layer);
    }

    /**
     * Metod som triggras när ett dataslag har blivit högerklickat på.
     * @param event
     * @param layer Det dataslag som klickats på
     * @returns false;
     */
    public onRightClick(event: any, layer: LayerListItem) {
        this.infoAboutLayer(layer);
        return false;
    }

    /**
     * Metod som öppnar modal som visar information om nuvarande lager.
     * @param layer
     */
    public async infoAboutLayer(layer: LayerListItem) {

        this.apmService.renameCurrentTransaction("Open info modal");

        const modal = this.trvModalService.open(LayerInfoModalComponent, {
            disposeOnBackdropClick: true,
            size: this.nvdbNavigation.isMobileDevice ? "fullscreen" : "md",
        });
        const component = modal.componentInstance;
        component.title = layer.name;

        let metaKey: string = "";
        if (layer.trvData.hasOwnProperty("metaKey")) metaKey = (layer.trvData as any).metaKey;

        if (layer.trvData.hasOwnProperty("description")) {
            layer.description = (layer.trvData as any).description;
        } else {
            if (metaKey != "") {
                var desc = await firstValueFrom(this.netDbService.getDescription(metaKey));
                desc = desc.replace("\n", "<br>");
                layer.description = desc;
            }
        }

        component.text = layer.description ? layer.description : this.lang.GetValue("Layerlist.LacksDescrip");
        component.layerVisibleFrom = layer.maxScaleDenominator ? Math.round(layer.maxScaleDenominator) : layer.maxScaleDenominator;
        component.legendGraphics = layer.legendGraphics;
        component.layer = layer;

        modal.afterCloseWithType().subscribe(closeParams => {
            //console.log(closeParams)
        });
    }

    handleFocusKeys($event: any, key: FocusKey) {
        $event.preventDefault();  // Prevent default action if necessary

        let _currentlyFocusedDataslagNumber = this.currentlyFocusedDataslagNumber;
        const allDataslagItems = document.getElementsByClassName("dataslag-item");

        const exampleDataslagItem = allDataslagItems[0] as HTMLElement;
        const computedStyle = window.getComputedStyle(exampleDataslagItem);

        const heightOfSingleItem = exampleDataslagItem.getBoundingClientRect().height +
            parseFloat(computedStyle.marginTop) +
            parseFloat(computedStyle.marginBottom);

        const currentContainerScrolloff = this.scrollContainer.nativeElement.scrollTop;

        const viewableMargin = 0.3 // if less than 30% of the item is viewable, its considered not viewable
        const firstViewable = Math.floor((currentContainerScrolloff / heightOfSingleItem) + viewableMargin)
        const lastViewable = Math.floor(((currentContainerScrolloff + this.scrollContainer.nativeElement.getBoundingClientRect().height) / heightOfSingleItem) - viewableMargin)

        const isItemInView = firstViewable <= _currentlyFocusedDataslagNumber && _currentlyFocusedDataslagNumber <= lastViewable

        switch (key) {
            case FocusKey.ARROW_DOWN:
                if (isItemInView) {
                    _currentlyFocusedDataslagNumber++;
                } else {
                    _currentlyFocusedDataslagNumber = firstViewable
                }
                break;
            case FocusKey.ARROW_UP:
                if (isItemInView) {
                    _currentlyFocusedDataslagNumber--;
                } else {
                    _currentlyFocusedDataslagNumber = lastViewable
                }

                break;
            case FocusKey.ENTER:
                if (!(_currentlyFocusedDataslagNumber >= 0 && _currentlyFocusedDataslagNumber <= this.filteredDataslagLayers.length - 1)) {
                    return;
                }

                const isActive = this.filteredDataslagLayers[_currentlyFocusedDataslagNumber].active
                this.filteredDataslagLayers[_currentlyFocusedDataslagNumber].active = !isActive
                this.onWmsLayerInputChange(this.filteredDataslagLayers[_currentlyFocusedDataslagNumber].active, this.filteredDataslagLayers[_currentlyFocusedDataslagNumber])
        }

        this.currentlyFocusedDataslagNumber = Math.min(Math.max(_currentlyFocusedDataslagNumber, 0), this.filteredDataslagLayers.length - 1); // dont allow less than 0 or more than the amount of items
        const highlightedItem = allDataslagItems[this.currentlyFocusedDataslagNumber];
        highlightedItem.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
    }

    protected readonly FocusKey = FocusKey;
}

enum FocusKey {
    ARROW_DOWN,
    ARROW_UP,
    ENTER
}

export interface NjdbDataslagFilter {
    id: number;
    name: string;
}
